import { Outlet, useNavigate } from "react-router-dom";
import './../../assets/styles/fintech.css'
import Header from "../../components/logistics/Header";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import Footer from "../../components/logistics/Footer";
import Settings from "../../components/management/Settings";
import { useEffect, useState } from "react";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import ThemeProvider from "../../hooks/themeProvider";
import { websites } from "../../redux/websites/action";
import { websiteCards } from "../../redux/websiteCards/action";
import { getBrandMapping } from "../../common/services/website-card.service";
import _ from "lodash"
import PageLoader from "../../components/PageLoader";
import { cargoLeads } from "../../redux/cargo-lead/action";
import { leads } from "../../redux/leads/action";
import { metaTokens } from "../../redux/meta-token/action";
import { getGatewayId, getGatewayuri, getHostName, getOrigin } from "../../common/services/common.service";

const LogisticsLayout = () => {

	const { height, width } = useWindowDimensions();
	const dispatch = useAppDispatch()
	const [color, setColor] = useState('universal')
	const handleSettigns = () => {
		dispatch(settings.set({ visible: !visible }))
	}

	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar, theme, isThemeAvailable, tenantId } = result
	// useEffect(() => {
	// 	setColor(theme)
	// 	if (theme == 'darkmode') {
	// 		dispatch(settings.set({ primary: '#f5e93cac' }))
	// 		dispatch(settings.set({ secondary: '#ffffff' }))

	// 	}
	// 	else if (theme == 'lightmode') {
	// 		dispatch(settings.set({ primary: '#ffffffa2' }))
	// 		dispatch(settings.set({ secondary: '#000000a2' }))
	// 	}
	// 	else if (theme == 'universal') {
	// 		dispatch(settings.set({ primary: '#233C64' }))
	// 		dispatch(settings.set({ secondary: '#ffffff' }))
	// 	}
	// 	else if (theme == 'luxury') {
	// 		dispatch(settings.set({ primary: '#bd238c' }))
	// 		dispatch(settings.set({ secondary: '#ffffff' }))

	// 	}
	// 	else if (theme == 'harmony') {
	// 		dispatch(settings.set({ primary: '#000000a2' }))
	// 		dispatch(settings.set({ secondary: '#000000a2' }))
	// 	}
	// 	else if (theme == 'warmth') {
	// 		dispatch(settings.set({ primary: '#000000a2' }))
	// 		dispatch(settings.set({ secondary: '#ffffff' }))

	// 	}
	// 	// const data = document.getElementById("layer") as HTMLInputElement;
	// 	// data.setAttribute("fill", "#603812")
	// 	// data.setAttribute("stroke", "#603812")
	// }, [theme]);

	const prepareTheme = async (cards: any) => {
		let _isThemeSelected = false
		const themes = await getBrandMapping(cards, 'ONE_DIGIIT_HOME_BRAND_MAPPINGS')
		await _.map(themes, async (theme: any) => {
			console.log('setting dynamic theme', theme)
			await dispatch(settings.set({
				theme: theme?.themeName?.toLowerCase() || 'universal',
				darkLogo: theme.logoDark,
				lightLogo: theme.logoLight,
				favIcon: theme.favIconDark || theme.favIconLight,
				isThemeAvailable: true,
			}))
			_isThemeSelected = true

			localStorage.setItem("theme", theme?.themeName?.toLowerCase() || 'universal')
		})
		if (!_isThemeSelected) {
			prepareDefaultTheme()
		}
	}

	const prepareDefaultTheme = () => {
		dispatch(settings.set({
			theme: 'universal',
			darkLogo: '/assets/images/100x100.png',
			lightLogo: '/assets/images/100x100.png',
			favIcon: '/assets/images/16x16.png',
			isThemeAvailable: true,
		}))
	}

	useEffect(() => {
		const loadSequentially = async () => {
			await dispatch(cargoLeads.resetAction({ actionType: 'create' }))
			await dispatch(leads.resetAction({ actionType: 'create' }))
			if (!tenantId || tenantId === -1) return;
			try {
				await dispatch(metaTokens.resetAction({ actionType: 'list' }));
				const metaData: any = await dispatch(metaTokens.list({
					url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/iam/token-service/meta-token`, entity: 'metaTokens', jsonData: {
						"Records": [
							{
								"Context": {
								"domain": "string",
								"core_version": "string",
								"Gateway_id": getGatewayId(),
								"Gateway_uri": getGatewayuri(),
								"bap_id": getHostName(),
								"bap_uri": getOrigin(),
								"bpp_id": "string",
								"bpp_uri": "string",
								"city": "string",
								"country": "string",
								"action": "string",
								"transaction_id": "string",
								"message_id": "string",
								"timestamp": "2025-05-20T08:59:12.805Z",
								"ttl": "string",
								"Subscription": "One-X",
								"Domain": "ONE",
								"SubDomains": [],
								"Network": "Internal",
								"Application": "Management",
								"Channel": "Portal"
							},
								"Message": {
								}
							}
						]
					}
				}))
				const firstWebsiteId = metaData?.items?.Website?.Id;
				await dispatch(websites.resetAction({ actionType: 'list' }));
				await dispatch(websiteCards.resetAction({ actionType: 'list' }));
				const cardsData: any = await dispatch(websiteCards.list({
					url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/fetch`, entity: 'websiteCards', jsonData: {
						"Records": [
							{
								"Context": {
								},
								"Message": {
									"TenantId": tenantId,
									"Id": firstWebsiteId
								}
							}
						]
					}, options: { authorization_required: false }
				}))

				if (cardsData?.items?.length > 0) {

					prepareTheme(cardsData?.items);
				} else {
					prepareDefaultTheme();
				}

			} catch (error) {
				console.error('Error during sequential loading', error);
				prepareDefaultTheme();
			}
		};

		loadSequentially();

	}, [dispatch, tenantId]);

	if (!isThemeAvailable) {
		console.log('theme not loaded')
		return (
			<>
				<PageLoader />
			</>
		)
	}

	return (
		<>
			<ThemeProvider>
				<div className="leading-normal tracking-normal" id="main-body">
					<div className="flex flex-wrap sm:hide">
						{visible ? <Settings /> : <></>}
						<div className="w-full bg-gray-100  min-h-screen" id="main-content">

							<Header />
							<div className="">
								<Outlet />
							</div>
							{footer ? <Footer /> : ""}
						</div>
					</div>
				</div>
			</ThemeProvider>
		</>
	)
}
export default LogisticsLayout;